import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_626ab134 from 'nuxt_plugin_sentryserver_626ab134' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_069d80a8 from 'nuxt_plugin_sentryclient_069d80a8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_nuxtmq_ac687310 from 'nuxt_plugin_nuxtmq_ac687310' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_webfontloader_158b9120 from 'nuxt_plugin_webfontloader_158b9120' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_veevalidate_07a1324a from 'nuxt_plugin_veevalidate_07a1324a' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_moment_00de5e28 from 'nuxt_plugin_moment_00de5e28' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vueowlcarousel_a59e6b5e from 'nuxt_plugin_vueowlcarousel_a59e6b5e' // Source: ../../../plugins/vue-owl-carousel.js (mode: 'client')
import nuxt_plugin_vuemasonry_56b6c12f from 'nuxt_plugin_vuemasonry_56b6c12f' // Source: ../../../plugins/vue-masonry.js (mode: 'client')
import nuxt_plugin_countup_4ddc21c3 from 'nuxt_plugin_countup_4ddc21c3' // Source: ../../../plugins/countup.js (mode: 'client')
import nuxt_plugin_setABtestVariable_d64837c8 from 'nuxt_plugin_setABtestVariable_d64837c8' // Source: ../../../plugins/setABtestVariable.js (mode: 'client')
import nuxt_plugin_setUtmParameters_5531c3ea from 'nuxt_plugin_setUtmParameters_5531c3ea' // Source: ../../../plugins/setUtmParameters.js (mode: 'client')
import nuxt_plugin_contentful_0fea6d46 from 'nuxt_plugin_contentful_0fea6d46' // Source: ../../../plugins/contentful.js (mode: 'all')
import nuxt_plugin_vuemodal_46b5cf07 from 'nuxt_plugin_vuemodal_46b5cf07' // Source: ../../../plugins/vue-modal.js (mode: 'client')
import nuxt_plugin_helpers_1c816d70 from 'nuxt_plugin_helpers_1c816d70' // Source: ../../../plugins/helpers.js (mode: 'all')
import nuxt_plugin_googleoptimize_684c8155 from 'nuxt_plugin_googleoptimize_684c8155' // Source: ./google-optimize.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"세무법인 혜움 - 국내 1위 카톡 기반 세무 서비스","htmlAttrs":{"lang":"ko"},"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"세무법인 혜움 - 국내 1위 카톡 기반 세무 서비스"},{"hid":"publisher","name":"publisher","content":"세무법인혜움"},{"hid":"author","name":"author","content":"세무법인혜움"},{"hid":"robots","name":"robots","content":"all"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"세무법인 혜움 - 국내 1위 카톡 기반 세무 서비스"},{"hid":"og:description","property":"og:description","content":"세무법인 혜움 - 국내 1위 카톡 기반 세무 서비스"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.heumtax.com\u002F"},{"hid":"og:image","property":"og:image","content":"\u002Fimages\u002Fcommon\u002Fheum_logo_white.jpg"},{"hid":"naver-site-verification","name":"naver-site-verification","content":"05669c5fb33ac5d689bb78ac9979b8ff2e03e1ee"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fbabel-polyfill\u002F7.11.5\u002Fpolyfill.min.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_626ab134 === 'function') {
    await nuxt_plugin_sentryserver_626ab134(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_069d80a8 === 'function') {
    await nuxt_plugin_sentryclient_069d80a8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_ac687310 === 'function') {
    await nuxt_plugin_nuxtmq_ac687310(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_158b9120 === 'function') {
    await nuxt_plugin_webfontloader_158b9120(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_07a1324a === 'function') {
    await nuxt_plugin_veevalidate_07a1324a(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_00de5e28 === 'function') {
    await nuxt_plugin_moment_00de5e28(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueowlcarousel_a59e6b5e === 'function') {
    await nuxt_plugin_vueowlcarousel_a59e6b5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemasonry_56b6c12f === 'function') {
    await nuxt_plugin_vuemasonry_56b6c12f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_countup_4ddc21c3 === 'function') {
    await nuxt_plugin_countup_4ddc21c3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setABtestVariable_d64837c8 === 'function') {
    await nuxt_plugin_setABtestVariable_d64837c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setUtmParameters_5531c3ea === 'function') {
    await nuxt_plugin_setUtmParameters_5531c3ea(app.context, inject)
  }

  if (typeof nuxt_plugin_contentful_0fea6d46 === 'function') {
    await nuxt_plugin_contentful_0fea6d46(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemodal_46b5cf07 === 'function') {
    await nuxt_plugin_vuemodal_46b5cf07(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_1c816d70 === 'function') {
    await nuxt_plugin_helpers_1c816d70(app.context, inject)
  }

  if (typeof nuxt_plugin_googleoptimize_684c8155 === 'function') {
    await nuxt_plugin_googleoptimize_684c8155(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
